import React from 'react';
import '../../css/loader.css'

function refresh() {

    return (
        <div>
            <div className="loader-overlay flex items-center justify-center fixed top-0 left-0 w-full h-full bg-opacity-50 z-50">
                    <div className="terminal-loader">
                        <div className="terminal-header">
                            <div className="terminal-title">Status</div>
                            <div className="terminal-controls">
                                <div className="control close"></div>
                                <div className="control minimize"></div>
                                <div className="control maximize"></div>
                            </div>
                        </div>
                        <div className="text">Refreshing...</div>
                    </div>
                </div>
        </div>

    );
}

export default refresh;
